import { useEffect, useState } from 'react';
import { MOBILE_BREAKPOINT } from '../../../../../constants/componentStaticData';
import { ChevronRight } from '../../../../Icons/rightArrow/ChevronRight';
import { useViewport } from '../../../../hooks';
import { TProductGuideStep } from '../../data/product-guide.data';

interface IDropDownSection {
  item: TProductGuideStep | undefined;
  activeTab: string;
  step: number;
  showArrow?: boolean;
}

export const DropDownSection = ({
  item,
  activeTab,
  step = 1,
  showArrow = true,
}: IDropDownSection) => {
  const [windowWidth, setWidth] = useState(1024);
  const { width } = useViewport();
  const isMobile = windowWidth && windowWidth < MOBILE_BREAKPOINT;

  useEffect(() => {
    const { innerWidth: widthValue } = window;
    setWidth(widthValue);
  }, [width]);

  const stepCountText = (
    <div>
      <span className="text-s-12 text-grey-900">Step</span>
      <span className="text-s-14 text-grey-900"> {step}</span>
      <span className="text-s-10 text-grey-500">/8</span>
    </div>
  );
  const stepCountTextVariant = isMobile ? stepCountText : `${step}.`;

  if (!item) return <></>;

  return (
    <>
      <div className="w-6 text-center sm:w-auto">
        {item.icon
          ? item.icon(activeTab === item.id ? '#0E4EA2' : '#70757B')
          : stepCountTextVariant}
      </div>
      <div className="flex items-center gap-2">
        {item.title}
        {showArrow && <ChevronRight className="rotate-90" color="#0E4EA2" />}
      </div>
    </>
  );
};
